export enum themeModes {
  dark = 'dark',
  light = 'light',
}
